<template>
  <LayoutPublic>
    <NavBarPublic />
    <HeroSection :data-hero="dataHero" />
    <div class="container mb-5">
      <div
        class="m-1 bg-white long-shadow"
        style="border-radius:5px;min-height: 100vh;overflow:hidden"
      >
        <section
          id="support-us"
          class="support-us"
          v-if="beritaShow"
        >
          <div class="row">
            <div class="col-12">
              <h4>{{ beritaShow.judul_berita }}</h4>
              <p>
                <small>
                  Ditulis oleh {{ beritaShow.penulis.penduduk.nama_lengkap }},
                  Pada {{ beritaShow.created_at }}
                </small>
              </p>
              <hr>
              <div
                class="berita-content"
                v-html="beritaShow.konten_berita"
              />
            </div>
          </div>
        </section>
      </div>
    </div>
		
    <FooterPublic />
  </LayoutPublic>
</template>

<style scoped>
	#info-layanan, .support-us {
		padding: 50px;
	}
	#info-layanan .btn {
		border-radius: 3px;
		padding-left: 30px;
		padding-right: 30px;
		height: 60px;
		line-height: 44px;
		font-size: 16px;
	}
	#support-us {
		border-top: 1px solid rgba(0,0,0,.04);
	}
	/* .support-us .container:after {
		left: 50px;
		right: initial;
		top: 50px;
		bottom: 50px;
		border-radius: 50% 50% 30% 30%;
		width: 50%;
	} */
	.support-us .container:after {
		display: none;
	}
	.list-icons {
		padding: 0;
		margin: 0;
		margin-top: 30px;
	}
	.list-icons li {
		display: flex;
		padding: 10px 0px;
		transition: all .5s;
	}
	.list-icons li:hover {
		background: #eee;
	}
	.list-icons li .card-icon {
		height: 50px;
		width: 50px;
		line-height: 52px;
	}
	.card-icon {
		width: 50px;
		height: 50px;
		border-radius: 3px;
		text-align: center;
		margin-right: 20px;
		flex-grow: 0;
		flex-shrink: 0;
	}
	#info-layanan {
		margin-top:100px;
	}
	.title-layanan {
		margin-top: 100px;
		margin-bottom: 0px;
	}

	@media screen and (max-width: 768px) {
		#info-layanan {
			margin-top: -100px;
		}
		.title-layanan {
			margin-bottom: 140px;
		}
	}
</style>

<script>
import swal from 'sweetalert'
import LayoutPublic from '../../../views/layouts/Public.vue'
import NavBarPublic from '../../../components/layout/NavBarPublic.vue'
import HeroSection from '../../../components/layout/HeroSection.vue'
import FooterPublic from '../../../components/layout/FooterPublic.vue'

export default {
	name: 'App',
	data(){
		return {
			dataHero: {
				title: 'Layanan Dokumen Kependudukan Aplikasi SiPeDuLi Jembrana',
				desc: 'Berbagai jenis permohonan terkait dokumen kependudukan tersedia di Aplikasi SiPeDuLi Jembrana',
				action: 'daftar',
				img: 'home'
			}
		}
	},
	computed: {
		beritaShow(){
			return this.$store.getters.getBeritaShow
		}
	},
	components: {
		LayoutPublic, NavBarPublic, HeroSection, FooterPublic
	},
	methods: {
		setImgContent(){
			let img = document.querySelectorAll('.berita-content img')

			img.forEach(e => {
				
				e.style.maxWidth = '100%'
				e.style.cursor = 'pointer'

				e.addEventListener('click', () => {
					var iframe = "<iframe width='100%' height='100%' src='" + e.getAttribute('src') + "'></iframe>"
					var x = window.open()
					x.document.open()
					x.document.write(iframe)
					x.document.close()
				})
			})

		}
	},
	created(){
		this.$store.dispatch('showBerita', this.$route.params.slug).then(res => {
			if(res.data.data){
				let show = res.data.data
				let date = new Date(show.created_at)
				let created_at = date.toLocaleDateString('id-ID', {year: 'numeric', month: 'short', day: 'numeric'})
				created_at += ' ' + date.toLocaleTimeString('it-IT')
				show.created_at = created_at
				this.$store.dispatch('setBeritaShow', show)
				
				// agak delay v-html nya
				setTimeout(() => {
					this.setImgContent()
				}, 500)
			}
		})
		.catch(err => {
			switch(err.response.status){
				case 500:
					this.$router.push({path: '/500'})
					break;
					
				case 404:
					this.$router.push({path: '/404'})
					break;

				case 400:
					swal({
						title: "Gagal",
						text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
						icon: "error",
						buttons: "Ok"
					})
					break;
				
				default:
					swal({
						title: "Gagal",
						text: err.response.data.message,
						icon: "error",
						buttons: "Ok"
					})
					break;
			}
		})
	},
	mounted(){
		document.querySelector('body').scrollIntoView()
		
		this.setImgContent()
	},
	watch: {
		beritaShow(newVal){
			// console.log(newVal.judul_berita.length)
			this.dataHero.title = newVal.judul_berita.substr(0, 50)
			this.dataHero.desc = newVal.snippet.substr(0, 100)

			this.setImgContent()
		}
	}
}
</script>

<style>

</style>
